import Marquee from "react-fast-marquee";

const ITEMS = [
  "Espresso cart",
  "Weddings",
  "Corporate mornings",
  "Snack platters",
  "Markets & festivals",
  "Espresso martinis",
  "Evening parties",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="py-10 border-y border-foreground/10 bg-alabaster overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-serif italic text-2xl sm:text-3xl text-espresso/80 px-8 whitespace-nowrap">{item}</span>
            <span className="w-2 h-2 bg-matcha rotate-45 shrink-0" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
